import React from "react";
import css from "./ScriptsBlog.module.css";
import {TextView,Title,BlogView, SectionView} from "Components";


export default function ScriptsBlog(){
    return (
        <BlogView className={css.scriptsblog}>
            <Title>Available Scripts</Title>
            <TextView>in your project root folder, you can run:</TextView>
            <ul className={css.scripts}>
                {statics.scripts.map(({npmcmd,description,options})=>
                    <li key={npmcmd} id={"npm"+npmcmd.replace(/ /g,"")}>
                        <Title className={css.cmdname}>npm {npmcmd}</Title>
                        <TextView>{description}</TextView>
                        {options&&<div className={css.options}>
                            {options.map(option=><SectionView
                                {...option}
                                titleSize={5}
                                key={option.name}
                                title={option.name}
                                text={option.description}
                            />)}
                        </div>}
                    </li>
                )}
            </ul>
        </BlogView>
    )
}

const statics={
    scripts:[
        {
            npmcmd:"start",
            description:`
                starts a Webpack server in development mode by default. 
                @you can view the app through 
                <a href="http://localhost:3000" target="_blank" rel="noopener noreferrer">http://localhost:3000</a> 
                in your browser.
                @The page will refresh when you make changes, and any lint errors will be displayed in the console as well.
            `,
            options:[
                {
                    name:"--env=test",
                    description:"if specified, will start a Phonegap server in testing mode instead",
                    cli:{lines:[
                        "npm start -- --env=test",
                        "#shorthand",
                        "npm start -- -t",
                    ]},
                },
                {
                    name:"--port",
                    description:"specifies a server port (default to 3000)",
                    cli:{lines:["npm start -- --port=3333"]},
                },
            ],
        },
        {
            npmcmd:"run watch",
            description:"watches the src folder and updates the content of the www folder accordingly.",
            options:[{
                name:"--env=<env_id>",
                description:`
                    Used to watch the app in a specific environment:
                    @--env=dev : development (default)
                    @--env=test : testing
                    @--env=prod : production
                `,
                cli:{lines:["npm run watch"]},
            }],
        },
        {
            npmcmd:"run build",
            description:`
                Builds the app to the <b>www</b> folder. 
                @In production mode, it optimizes and minifies files for the best performance.
            `,
            options:[{
                name:"--env=<env_id>",
                description:`
                    Used to build the app in a specific environment:
                    @--env=prod : production (default)
                    @--env=test : testing
                    @--env=dev : development
                `,
                cli:{lines:[
                    "npm run build -- --env=dev",
                    "#shorthand",
                    "npm run build -- -d",
                ]},
            }],
        },
        {
            npmcmd:"run extract",
            description:`
                If the webpack default configuration is not enough and customization via 
                a <b>vritra.config.js</b> file still does not suit your needs, 
                you can extract the default <b>webpack.config.js</b> file.
                @This command will add the config file to your app root folder if none
                exists and does nothing else. You can then remove the <b>vritra-scripts</b>
                package and install the dev packages required 
                for your custom configuration.
                @To get back to the default vritra configs, just reinstall 
                vritra-scripts again, and reset your project scripts 
                in your package.json file.
            `,
            notice:`
                Be careful while editing your webpack.config.js, some configuration 
                is required to keep your project working and behaving as expected.
            `,
        },
    ],
}
